/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageAttachmentResponseDto } from './MessageAttachmentResponseDto';
import {
    MessageAttachmentResponseDtoFromJSON,
    MessageAttachmentResponseDtoFromJSONTyped,
    MessageAttachmentResponseDtoToJSON,
    MessageAttachmentResponseDtoToJSONTyped,
} from './MessageAttachmentResponseDto';
import type { MessageSenderDto } from './MessageSenderDto';
import {
    MessageSenderDtoFromJSON,
    MessageSenderDtoFromJSONTyped,
    MessageSenderDtoToJSON,
    MessageSenderDtoToJSONTyped,
} from './MessageSenderDto';

/**
 * 
 * @export
 * @interface MessageDto
 */
export interface MessageDto {
    /**
     * Message ID
     * @type {string}
     * @memberof MessageDto
     */
    id: string;
    /**
     * Conversation ID
     * @type {string}
     * @memberof MessageDto
     */
    conversationId: string;
    /**
     * Message content
     * @type {string}
     * @memberof MessageDto
     */
    content?: string;
    /**
     * Message type
     * @type {string}
     * @memberof MessageDto
     */
    messageType: MessageDtoMessageTypeEnum;
    /**
     * Message attachments
     * @type {Array<MessageAttachmentResponseDto>}
     * @memberof MessageDto
     */
    attachments?: Array<MessageAttachmentResponseDto>;
    /**
     * Timestamp when the message was read
     * @type {Date}
     * @memberof MessageDto
     */
    readAt?: Date;
    /**
     * Message creation timestamp
     * @type {Date}
     * @memberof MessageDto
     */
    createdAt: Date;
    /**
     * Message update timestamp
     * @type {Date}
     * @memberof MessageDto
     */
    updatedAt: Date;
    /**
     * Sender information
     * @type {MessageSenderDto}
     * @memberof MessageDto
     */
    sender?: MessageSenderDto;
}


/**
 * @export
 */
export const MessageDtoMessageTypeEnum = {
    Text: 'text',
    File: 'file',
    Image: 'image'
} as const;
export type MessageDtoMessageTypeEnum = typeof MessageDtoMessageTypeEnum[keyof typeof MessageDtoMessageTypeEnum];


/**
 * Check if a given object implements the MessageDto interface.
 */
export function instanceOfMessageDto(value: object): value is MessageDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('messageType' in value) || value['messageType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MessageDtoFromJSON(json: any): MessageDto {
    return MessageDtoFromJSONTyped(json, false);
}

export function MessageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'conversationId': json['conversationId'],
        'content': json['content'] == null ? undefined : json['content'],
        'messageType': json['messageType'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(MessageAttachmentResponseDtoFromJSON)),
        'readAt': json['readAt'] == null ? undefined : (new Date(json['readAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'sender': json['sender'] == null ? undefined : MessageSenderDtoFromJSON(json['sender']),
    };
}

export function MessageDtoToJSON(json: any): MessageDto {
    return MessageDtoToJSONTyped(json, false);
}

export function MessageDtoToJSONTyped(value?: MessageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conversationId': value['conversationId'],
        'content': value['content'],
        'messageType': value['messageType'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(MessageAttachmentResponseDtoToJSON)),
        'readAt': value['readAt'] == null ? undefined : ((value['readAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'sender': MessageSenderDtoToJSON(value['sender']),
    };
}

